"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.S3Client = void 0;
var _nodeStream = require("node:stream");
var _clientS = require("@aws-sdk/client-s3");
// See: https://docs.aws.amazon.com/sdk-for-javascript/v3/developer-guide/javascript_s3_code_examples.html

class S3Client {
  constructor(client, logger) {
    this.logger = logger;
    this.client = client;
  }

  /**
   * Download a file from a specified S3 bucket
   */
  async readFile(fileKey, opts) {
    this.logger?.info(`Downloading from S3. bucket: ${opts.bucket}, key: ${fileKey}`);

    // Request the file from s3
    const command = new _clientS.GetObjectCommand({
      Bucket: opts.bucket,
      Key: fileKey
    });
    const response = await this.client.send(command);

    // Check the file exists
    if (!response.Body) {
      throw new Error(`S3 file not found. bucket: ${opts.bucket}, key: ${fileKey}`);
    }
    return _nodeStream.Readable.fromWeb(response.Body.transformToWebStream());
  }

  /**
   * Upload file to a specified S3 bucket
   */
  async writeFile(fileKey, content, opts) {
    this.logger?.info(`Writing to S3. bucket: ${opts.bucket}, key: ${fileKey}`);
    const command = new _clientS.PutObjectCommand({
      Bucket: opts.bucket,
      Key: fileKey,
      Body: content
    });
    await this.client.send(command);
  }
}
exports.S3Client = S3Client;